import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { combineLatest, filter, map } from 'rxjs';
import { FacadeService } from '../services/facade.service';

@Injectable({
  providedIn: 'root',
})
export class TokenService {
  constructor(private facade: FacadeService, private router: Router, private route: ActivatedRoute) {}

  canActivateLogged() {
    return combineLatest([
      this.facade.guard.selectToken$,
      this.facade.guard.selectIsLottomatica$,
      this.route.queryParams
    ]).pipe(
      map(([token, isLottomatica, params]) => {
        if (!token && !isLottomatica && !params?.['channel']) {
          return this.router.createUrlTree(['/login']);
        }

        return !!token || isLottomatica;
      })
    );
  }

  canActivateNotLogged() {
    return combineLatest([
      this.facade.guard.selectToken$,
      this.facade.guard.selectIsLottomatica$,
    ]).pipe(
      map(([token, isLottomatica]) => {
        if (token || isLottomatica) {
          return this.router.createUrlTree(['/']);
        }

        return !token;
      })
    );
  }

  canActivateMaintainance() {
    return this.facade.guard.selectIsMaintainance$.pipe(
      filter((isMaintainance) => isMaintainance !== undefined),
      map((isMaintainance) => {
        if (isMaintainance) {
          return this.router.createUrlTree(['/manutenzione']);
        }

        return !isMaintainance;
      })
    );
  }

  canActivateNotMaintainance() {
    return this.facade.guard.selectIsMaintainance$.pipe(
      filter((isMaintainance) => isMaintainance !== undefined),
      map((isMaintainance) => {
        if (!isMaintainance) {
          return this.router.createUrlTree(['/']);
        }

        return isMaintainance;
      })
    );
  }
}
